import { ColumnKey } from '../DataGrid.types'

export interface GetColumnValueParams<RowType> {
  columnKey: ColumnKey
  rowData: RowType
}

export function getColumnValue<RowType>({ columnKey, rowData }: GetColumnValueParams<RowType>) {
  if (!rowData || typeof rowData !== 'object') {
    return undefined
  }

  const keys = columnKey.split('.')

  if (keys.length === 1 && keys[0] in rowData) {
    return rowData[keys[0] as keyof RowType] ?? undefined
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let value: any = rowData
  for (const key of keys) {
    if (!value || !(key in value)) {
      return undefined
    }

    value = value[key as keyof typeof value]
  }

  return value
}
